import React from 'react';

function Loading() {
  return (
    <div className="loading-message">Carregando...</div>
  );
}

export default Loading;
